import { h, Component } from 'preact';
import { connect } from 'preact-redux';         // Themes Top Budget Sources, Top Recipient countries

import { fetchSdgSunburstData } from '../../../components/paLandingPage/actions';
import PreLoader from '../../../components/preLoader';
import style from './style';

import PaSunburstChart from '../../../components/paSunburstChart';

class EmbedSdgLandingView extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }


    componentWillMount() {
        this.props.fetchSdgSunburstData(this.props.currentYear)
    }

    componentWillReceiveProps(nextProps) {
    }
    handleOnClick = (e) => {
		if (e.size && e.size != 1) { }
	}
	onTargetClick = (e) => {
		if (e.name) {
			let targetIds = e.name.replace('Target', '').trim().split('.');
            window.open('/sdg/targets/' + targetIds[0] + '/' + targetIds[1], '_blank');
		}
	}
	onSDGClick = (e) => {
		if (e.parent.name.includes('SDG')) {
            window.open('/sdg/' + e.parent.code + '/' + e.parent.fullName, '_blank');
		}
	}
    render(props, {}) {
        return (
            <div>
               {
                   (this.props.title !== 'false') ?
                   <div class={style.titleWrapper}>
                        IUCN Programme Areas
                    </div>
                    :null
               }
                {
                    (this.props.summary !== 'false') ?
                    <div>
                        <span class={style.SDGdisclaimer}>
                        IUCN’s One Programme approach underpins and strengthens the delivery and impact of the IUCN Programme, effectively leveraging the respective roles, capacities and unique features of the constituent parts of the Union – our Members, Commissions, National and Regional Committees and Secretariat – in partnership with a diversity of sectors engaged in the sustainable development agenda. In a world facing unprecedented planetary challenges, IUCN is unique in its ability to respond at the scale needed for positive, timely transformative action for a more sustainable future. This uniqueness draws from IUCN’s convening power, scientific strength, broad and diverse membership, and truly global presence. The Union will take advantage of its unique structure: generating the necessary science-based evidence and knowledge that decision makers require, building trust and consensus among disparate stakeholder groups, identifying feasible policy options and, critically, fostering a culture of delivery and action that accelerates early and sustainable implementation. It will deliver concrete and tangible positive impacts to People, Land, Water, Oceans and Climate.
                        </span>
				    </div>
                    :null
                }
					{
						!this.props.sdgSunburstData.loading ?
						<div class={style.sunburstChartContainer}>
                        <PaSunburstChart chart_id="sdg_sunburst_chart"
											width={screen.width >= 650 ? 1600 : screen.width >= 550 ? 1200 : 1000}
											height={600}
											data={this.props.sdgSunburstData.data}
											handleOnClick={this.handleOnClick}
											onTargetClick={this.onTargetClick}
											onSDGClick={this.onSDGClick}
										/>
							
						</div>
						:
						<div style={{ position: 'relative', height: 344 }}>
							<PreLoader /> 
						</div>
					}
                </div>
        )
    }
}


const mapStateToProps = (state) => {
    const sdgSunburstData = state.sdgSunburstData,
        currentYear = state.yearList.currentYear;
		
	return {
        sdgSunburstData,
        currentYear
	};
};
const mapDispatchToProps = (dispatch) => ({
    fetchSdgSunburstData: (year) => dispatch(fetchSdgSunburstData(year))
});


export default connect(mapStateToProps, mapDispatchToProps)(EmbedSdgLandingView);



// WEBPACK FOOTER //
// ./routes/embedViews/paLanding/index.js